(() => {
  const $ = (s) => document.querySelector(s);

  // phone menu
  const btn = $("#menuBtn"), nav = $("#mobileNav");
  if (btn && nav) btn.addEventListener("click", () => {
    const open = nav.classList.toggle("open");
    btn.setAttribute("aria-expanded", open);
  });

  // "Tell Us About You" scrolls to the questionnaire
  document.addEventListener("click", (e) => {
    const a = e.target.closest("[data-scroll]");
    const q = $("#questionnaire");
    if (a && q) { e.preventDefault(); q.scrollIntoView({ behavior: "smooth" }); }
  });

  // after a signup posts, hide the hint under the hero form
  if (document.querySelector(".hero-copy .thanks")) {
    const hint = document.querySelector(".hero-copy > .h5");
    if (hint) hint.hidden = true;
  }
})();
